export const WEB_CASH_CHANGE_ACTIVE_PAGE = 'WEB_CASH/CHANGE_ACTIVE_PAGE';

export const WEB_CASH_RESET_OPTION = 'WEB_CASH/RESET_OPTION';
